import { IUnderwriterRemittanceData } from '../../../../types/order/escrow/IUnderwriterRemittanceData';
import { ICDV3ViewItem } from '../../../../ui-toolkit/cdItems/interfaces/ICDViewItem';

export interface IRemittanceAndCDItemData {
  remittance: IUnderwriterRemittanceData;
  cdItem: ICDV3ViewItem;
}

export const toRemoveAttached = (remittance: IUnderwriterRemittanceData): boolean =>
  (remittance.underwriterAchPushDisbursementId === null || remittance.underwriterAchPushDisbursementId === undefined) &&
  remittance.underwriterFeeAmountCents > 0;

export const toRemoveUnattached = (remittance: IUnderwriterRemittanceData): boolean =>
  remittance.underwriterAchPushDisbursementId !== null &&
  remittance.underwriterAchPushDisbursementId !== undefined &&
  remittance.underwriterFeeAmountCents > 0;

export const attachCDItemsToRemittanceItems = (
  remittanceList: IUnderwriterRemittanceData[],
  cdItemList: ICDV3ViewItem[]
): IRemittanceAndCDItemData[] | null => {
  if (remittanceList.find((remittance) => !cdItemList.find((cdItem) => cdItem.id === remittance.cdItemsV3Id))) {
    return null;
  }

  return remittanceList.map((t) => ({
    remittance: t,
    cdItem: cdItemList.find((cdItem) => cdItem.id === t.cdItemsV3Id)!,
  }));
};
